export function useDownloadFile() {
	function getFile(data: any, type: string, fileName: string) {
		const blob = new Blob([data], { type: type });
		const url = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.download = fileName;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	}
	return {
		getFile
	};
}